@if (!isLoading) {
  <p-dialog
    [(visible)]="canShowCustomerPreviewModel"
    [contentStyle]="{
      'max-height': '50em',
      width: 'auto',
      'z-index': '10030px'
    }"
    [closable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="false"
    [style]="{ width: '80%' }"
    styleClass="preview-modal">
    <ng-template #header>
      <div class="ui-g-11">Customer Validation Approval</div>
      <div
        class="ui-g-1 closesidebar diaclnav"
        (click)="closePreview()"
        (keypress.enter)="closePreview()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>

    <div class="ui-g">
      <div class="ui-g-3 bg-color-1">
        <div class="mb-3">
          <div class="title">{{ eventIdTitle }}</div>
          <div>{{ custValidationEventDetail.eventID }}</div>
        </div>
        <div class="mb-3">
          <div class="title">Workshop Type</div>
          <div class="word-wrap">
            {{ custValidationEventDetail.workshopType }}
          </div>
        </div>
        <div class="mb-3">
          <div class="title">Qualified Amount</div>
          <div class="word-wrap">
            ${{ custValidationEventDetail.qualifiedAmount | number: '' : 'en' }}
          </div>
        </div>
        <div class="mb-3">
          <div class="title">Partner organization</div>
          <div class="word-wrap">
            {{ custValidationEventDetail.partnerOrganization }}
          </div>
        </div>
        <div class="mb-3">
          <div class="title">Partner requestor email</div>
          <div class="word-wrap">
            {{ custValidationEventDetail.partnerEmail }}
          </div>
        </div>
        <div class="mb-3">
          <div class="title">Registration Date</div>
          <div>
            {{
              custValidationEventDetail.registrationDate | date: 'MM/dd/yyyy'
            }}
          </div>
        </div>
        <div class="mb-3">
          <div class="title">90 Day Expiration</div>
          <div>
            {{ custValidationEventDetail.dayExpiration90 | date: 'MM/dd/yyyy' }}
          </div>
        </div>
        <div class="mb-3">
          <div class="title">Workshop Completion Date</div>
          <div>
            @if (custValidationEventDetail.workshopCompletionDate !== null) {
              <span>
                {{
                  custValidationEventDetail.workshopCompletionDate
                    | date: 'MM/dd/yyyy'
                }}
              </span>
            }
            @if (custValidationEventDetail.workshopCompletionDate === null) {
              <span> NA </span>
            }
          </div>
        </div>
      </div>
      <div class="ui-g-9">
        <div class="ui-g-12 cust-detail">
          <div class="ui-g-12">
            <div class="ui-g">
              <div class="ui-g-6">
                <div class="ui-g-4 title">Status</div>
                <div class="ui-g-8">
                  <p-select
                    appendTo="body"
                    [options]="poeFilterOptions"
                    placeholder="--SELECT--"
                    optionLabel="status"
                    [(ngModel)]="selectedPoeFilter"
                    (onChange)="onStatusFilterChange()">
                  </p-select>
                </div>
              </div>
              <div class="ui-g-6">
                <div class="ui-g-4 title">Customer</div>
                <div class="ui-g-8">
                  <p-select
                    appendTo="body"
                    [disabled]="!eventCustomerValidation.length"
                    [options]="eventCustomerValidation"
                    placeholder="--SELECT--"
                    optionLabel="customerName"
                    [(ngModel)]="SelectedCustomer"
                    (onChange)="onCustomerChange($event)">
                  </p-select>
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g-12 cust-info">
            @if (!eventCustomerValidation.length) {
              <div class="empty-table">
                <p>No Records found.</p>
              </div>
            }
            @if (eventCustomerValidation.length) {
              <div>
                <div class="ui-g-12">
                  <div class="hdbl">Customer Information</div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <div class="ui-g-3 title">Name:</div>
                    <div class="ui-g-6">
                      {{
                        custValidationInfo && custValidationInfo.customerName
                      }}
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <div class="ui-g-3 title">Customer Country:</div>
                    @if (custValidationInfo !== null) {
                      <div class="ui-g-6">
                        {{
                          custValidationInfo &&
                          custValidationInfo.customerCountry
                            ? custValidationInfo.customerCountry
                            : 'NA'
                        }}
                      </div>
                    }
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <div class="ui-g-3 title">Validation Type:</div>
                    <div class="ui-g-6">
                      {{
                        custValidationInfo &&
                          custValidationInfo.eventCustomerValidationType
                      }}
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <div class="ui-g-3 title">Validation Details:</div>
                    @if (custValidationInfo !== null) {
                      <div class="ui-g-6">
                        {{ eventCustomerValidationDetail }}
                        <span
                          tabindex="0"
                          id="eventCustomerValidationDetail"
                          class="tooltip-style mdl2-copy email-copy"
                          (mouseenter)="setFocus()"
                          (mouseleave)="setFocusout()"
                          (keyup.enter)="
                            copyText(eventCustomerValidationDetail)
                          "
                          (click)="copyText(eventCustomerValidationDetail)">
                          @if (showToolTipCustomer) {
                            <span>
                              @if (!copiedValidationDetail) {
                                <span class="tooltiptext-copy">
                                  <span>Copy to clipboard</span>
                                </span>
                              }
                              @if (copiedValidationDetail) {
                                <span class="tooltiptext-copy-short">
                                  <span>Copied!</span>
                                </span>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g">
            <div class="ui-g-1"></div>
            <div class="ui-g-10">
              @for (message of msgsUsageDetails; track message) {
                <p-message [life]="3000" [text]="message.detail"></p-message>
              }
            </div>
            <div class="ui-g-1"></div>
            <div class="ui-g-1"></div>
            @if (!customerValidationPreviewInput.isEditPreview) {
              <div class="ui-g-1">
                <input
                  class="next-previous"
                  type="button"
                  value="« Previous"
                  [disabled]="!checkForPrevious()"
                  (click)="onPreviousClick()" />
              </div>
            }
            <div class="ui-g-8 center">
              <button
                type="button"
                pButton
                pTooltip="Reject"
                tooltipPosition="top"
                [disabled]="
                  IsCustomerValidationRejected() ||
                  !eventCustomerValidation.length
                "
                class="ui-button-info btnpad btnmr button-deny"
                (click)="onDenyOpen()">
                Reject
              </button>
              <button
                type="button"
                pButton
                pTooltip="Approve"
                tooltipPosition="top"
                [disabled]="
                  IsCustomerValidationApproved() ||
                  !eventCustomerValidation.length
                "
                class="ui-button-info btnpad btnmr button-approve"
                (click)="submitForApproval()">
                Approve
              </button>
            </div>
            @if (!customerValidationPreviewInput.isEditPreview) {
              <div class="ui-g-2">
                <input
                  class="next-previous"
                  type="button"
                  value="Next »"
                  [disabled]="!checkForNext()"
                  (click)="onNextClick()" />
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <p-dialog
      [(visible)]="customerValidationRejectionModalDisplay"
      [contentStyle]="{
        'max-height': '50em',
        width: 'auto',
        'z-index': '1038px'
      }"
      [closable]="false"
      [draggable]="false"
      showEffect="fade"
      [modal]="false"
      class="modal-position">
      <ng-template #header>
        <div class="ui-g-11">
          <span>Select reasons to reject</span>
        </div>
        <div
          class="ui-g-1 closesidebar diaclnav"
          (click)="closeDeclineModal()"
          (keydown.enter)="closeDeclineModal()"
          tabindex="0">
          <i class="mdl2-cancel close-icon"></i>
        </div>
      </ng-template>
      <form [formGroup]="formCustomerValidationRejection">
        <div class="mb-3">
          <div class="title">Reasons</div>
          <p-select
            appendTo="body"
            [options]="rejectionReason"
            placeholder="--SELECT--"
            optionLabel="rejectReasonDescription"
            formControlName="rejectionReason"></p-select>
        </div>
        <div class="mb-3">
          <div class="title">Additional Notes (Optional)</div>
          <div>
            <textarea
              pTextarea
              formControlName="additionalNotesRejectionReason"
              class="additional-notes p-1"
              placeholder="Enter Notes"
              rows="5"
              name="additionalNotesRejectionReason"
              maxlength="250"
              aria-label="additionalnotes"></textarea>
            <small class="form-text text-muted">
              <code>{{
                formCustomerValidationRejection.controls[
                  'additionalNotesRejectionReason'
                ].value
                  ? formCustomerValidationRejection.controls[
                      'additionalNotesRejectionReason'
                    ].value.length
                  : 0
              }}</code>
              of <code>250</code> characters
            </small>
          </div>
        </div>
        <button
          type="button"
          pTooltip="Ok"
          tooltipPosition="top"
          [disabled]="!customerDenyButtonEnable"
          class="ui-button-info btnpad btnmr button-ok"
          pButton
          (click)="onDeny()">
          Ok
        </button>
        <button
          type="button"
          pTooltip="Cancel"
          tooltipPosition="top"
          class="ui-button-info btnpad btnmr button-cancel"
          pButton
          (click)="closeDeclineModal()">
          Cancel
        </button>
      </form>
    </p-dialog>

    @if (isApproveReject) {
      <div class="loading-indicator">
        <p-progressSpinner></p-progressSpinner>
      </div>
    }
  </p-dialog>
}
